import { compareStateForCard } from 'utils/ducted-compare-state';
import { DuctedComparedSystem } from 'utils/ducted-compare-identity';
import { rankGroupCardSelection } from 'utils/ducted-rail-selections';
import { featuredRankGroupCard } from './ducted-rail-rank-groups';
import { DuctedRailSectionModel } from './ducted-rail-sections-types';

export function recommendedComparedIds(
  sections: DuctedRailSectionModel[],
  comparedIdByCardId: ReadonlyMap<string, string>,
  systemsToCompare: ReadonlyArray<DuctedComparedSystem>
): ReadonlySet<string> {
  const ids = new Set<string>();
  sections.forEach((section) => {
    section.rankGroups.forEach((group) => {
      const card = featuredRankGroupCard(group);
      const selection = card ? rankGroupCardSelection(section, card) : null;
      const comparedId = selection
        ? compareStateForCard(comparedIdByCardId, systemsToCompare, selection)
            .comparedId
        : undefined;
      if (comparedId !== undefined) ids.add(comparedId);
    });
  });
  return ids;
}
